// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.auth-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100000;
  width: min(720px, 100vw - 32px);
  max-height: calc(100vh - 32px);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 22px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.auth-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .auth-panel {
    animation: none;
  }
}
.auth-panel::-webkit-scrollbar {
  width: 6px;
}
.auth-panel::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.auth-panel h1, .auth-panel p {
  margin: 0;
}
.auth-panel--signin {
  width: min(420px, 100vw - 32px);
  gap: 14px;
}
.auth-panel--launch {
  width: min(380px, 100vw - 32px);
  align-items: center;
  gap: 12px;
  padding: 32px 28px 28px;
  text-align: center;
}
.auth-panel__launch-portrait {
  width: 150px;
  height: 190px;
  margin-bottom: 8px;
  overflow: hidden;
  background: #07090c;
  border: 1px solid var(--gold-dark);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-panel__launch-portrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 22%;
}
.auth-panel__progress {
  position: relative;
  width: 100%;
  height: 3px;
  margin-top: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 2px;
}
.auth-panel__progress::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 35%;
  background: var(--gold-main);
  border-radius: 2px;
  animation: auth-progress 1.3s ease-in-out infinite;
}
.auth-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}
.auth-panel__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 28px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.auth-panel__lead {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  margin-top: 6px;
}
.auth-panel--signin .auth-panel__lead {
  margin-top: 0;
}
.auth-panel--signin .auth-panel__button {
  margin-top: 6px;
}
.auth-panel__identity {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  max-width: 45%;
  padding: 5px 14px 5px 5px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 24px;
}
.auth-panel__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  font-weight: 600;
  font-size: 15px;
  color: #14100a;
  background: var(--gold-main);
}
.auth-panel__avatar--img {
  object-fit: cover;
  background: none;
}
.auth-panel__username {
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.auth-panel__characters {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.auth-panel__card {
  position: relative;
  height: clamp(260px, 100vh - 290px, 400px);
  overflow: hidden;
  background: #07090c;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  transition: border-color 0.12s ease;
}
.auth-panel__card:hover, .auth-panel__card:focus-within {
  border-color: var(--gold-main);
}
.auth-panel__card-main {
  position: absolute;
  inset: 0;
  cursor: pointer;
}
.auth-panel__card-main:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -3px;
}
.auth-panel__portrait {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-panel__portrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 22%;
  transition: transform 0.25s ease;
}
.auth-panel__card:hover .auth-panel__portrait img, .auth-panel__card:focus-within .auth-panel__portrait img {
  transform: scale(1.03);
}
.auth-panel__fallback {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 64px;
  color: #8d8a82;
}
.auth-panel__card-foot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 44px 16px 14px;
  background: linear-gradient(to top, rgba(5, 7, 10, 0.95), rgba(5, 7, 10, 0));
}
.auth-panel__card-name {
  min-width: 0;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 21px;
  line-height: 1.15;
  color: #ebe8e1;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.auth-panel__card-play {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--gold-light);
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity 0.14s ease, transform 0.14s ease;
}
.auth-panel__card:hover .auth-panel__card-play, .auth-panel__card:focus-within .auth-panel__card-play {
  opacity: 1;
  transform: none;
}
.auth-panel__delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  color: #aeaba2;
  background: rgba(7, 9, 12, 0.78);
  opacity: 0.55;
  transition: opacity 0.12s ease, background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.auth-panel__delete:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.auth-panel__delete:active:not(:disabled) {
  transform: translateY(1px);
}
.auth-panel__delete:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.auth-panel__delete:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.auth-panel__delete:hover:not(:disabled) {
  color: #d9786d;
  background: rgba(7, 9, 12, 0.92);
  border-color: #d9786d;
}
.auth-panel__card:hover .auth-panel__delete, .auth-panel__card:focus-within .auth-panel__delete {
  opacity: 1;
}
.auth-panel__card--empty {
  display: flex;
  background: rgba(255, 255, 255, 0.04);
  border-style: dashed;
  cursor: pointer;
}
.auth-panel__card--empty:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -3px;
}
.auth-panel__card--empty:hover {
  background: rgba(255, 255, 255, 0.07);
}
.auth-panel__card--locked {
  cursor: pointer;
}
.auth-panel__card--locked:hover, .auth-panel__card--locked:focus-within {
  border-color: rgba(255, 255, 255, 0.2);
}
.auth-panel__empty {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 20px;
  text-align: center;
}
.auth-panel__empty-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 19px;
  color: #ebe8e1;
}
.auth-panel__empty-sub {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.auth-panel__plus {
  position: relative;
  width: 44px;
  height: 44px;
  margin-bottom: 10px;
  border: 1px solid var(--gold-dark);
  border-radius: 50%;
}
.auth-panel__plus::before, .auth-panel__plus::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  background: var(--gold-main);
  transform: translate(-50%, -50%);
}
.auth-panel__plus::before {
  width: 16px;
  height: 2px;
}
.auth-panel__plus::after {
  width: 2px;
  height: 16px;
}
.auth-panel__confirm {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 8px;
  padding: 22px;
  background: rgba(8, 10, 13, 0.94);
  text-align: center;
}
.auth-panel__confirm-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 21px;
  line-height: 1.2;
  overflow-wrap: anywhere;
}
.auth-panel__confirm-text {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  margin-bottom: 10px;
}
.auth-panel__confirm-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.auth-panel__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 11px 18px;
  font-size: 15px;
}
.auth-panel__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.auth-panel__button:active:not(:disabled) {
  transform: translateY(1px);
}
.auth-panel__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.auth-panel__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.auth-panel__button--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.auth-panel__button--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.auth-panel__button--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.auth-panel__button--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.auth-panel__message {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  padding: 10px 12px;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 3px solid #d9786d;
  border-radius: 6px;
}

@media (max-width: 560px) {
  .auth-panel {
    padding: 18px;
  }
  .auth-panel__head {
    flex-direction: column;
  }
  .auth-panel__identity {
    max-width: 100%;
  }
  .auth-panel__characters {
    grid-template-columns: 1fr;
  }
  .auth-panel__card {
    height: 240px;
  }
}
@keyframes auth-progress {
  from {
    left: -35%;
  }
  to {
    left: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .auth-panel__progress::after {
    animation: none;
    left: 0;
    width: 100%;
    opacity: 0.5;
  }
  .auth-panel__portrait img,
  .auth-panel__card-play {
    transition: none;
  }
}
.auth-splash {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background-color: #0a0814;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: auth-splash-in 0.5s ease-out both;
}
.auth-splash__veil {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at center, rgba(10, 8, 20, 0.2) 0%, rgba(10, 8, 20, 0.78) 100%), linear-gradient(to bottom, rgba(10, 8, 20, 0.45), rgba(10, 8, 20, 0.7));
}
.auth-splash__center {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  width: min(460px, 100vw - 48px);
  text-align: center;
}
.auth-splash__emblem {
  width: clamp(96px, 16vh, 150px);
  height: auto;
  animation: auth-splash-glow 3.2s ease-in-out infinite;
}
.auth-splash__wordmark {
  width: min(360px, 70vw);
  height: auto;
}
.auth-splash__who {
  margin: 6px 0 0;
  font-size: 15px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #c9b0ff;
}
.auth-splash__progress {
  position: relative;
  width: 100%;
  height: 3px;
  overflow: hidden;
  background: rgba(236, 234, 245, 0.14);
  border-radius: 2px;
}
.auth-splash__progress::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 35%;
  background: #7c4de0;
  border-radius: 2px;
  animation: auth-progress 1.3s ease-in-out infinite;
}
.auth-splash__status {
  margin: 0;
  min-height: 1.4em;
  font-size: 13px;
  color: #a7a2bd;
}

@keyframes auth-splash-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes auth-splash-glow {
  0%, 100% {
    filter: drop-shadow(0 0 10px rgba(124, 77, 224, 0.35));
  }
  50% {
    filter: drop-shadow(0 0 26px rgba(124, 77, 224, 0.75));
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/AuthPanel/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAHA;ED2BE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECrKA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,+BAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EDkJA,gBAAA;EACA,qBAAA;EACA,qDAAA;ACtIF;ADEE;EAAI,sBAAA;ACCN;AD4IE;EC1KF;ID0K4C,eAAA;ECxI1C;AACF;ADgIE;EAAuB,UAAA;AC7HzB;AD8HE;EAA6B,oCAAA;EAAsC,kBAAA;AC1HrE;AA1BE;EAAQ,SAAA;AA6BV;AA3BE;EACE,+BAAA;EACA,SAAA;AA6BJ;AAzBE;EACE,+BAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;AA2BJ;AAxBE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBDnBK;ECoBL,aAAA;EACA,mBAAA;EACA,uBAAA;AA0BJ;AAxBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;AA0BN;AAtBE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,qCD7CG;EC8CH,kBAAA;AAwBJ;AAtBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,4BAAA;EACA,kBAAA;EACA,kDAAA;AAwBN;AApBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAsBJ;AAnBE;ED9BA,kDA3BW;EA4BX,gBAAA;EACA,eC4B8B;ED3B9B,iBAAA;EACA,sBAAA;EACA,cAxCK;AC4FP;AAzBE;EDvBA,eAAA;EACA,gBAAA;EACA,cA7CO;ECoEL,eAAA;AA6BJ;AA1BE;EAAoB,aAAA;AA6BtB;AA5BE;EAAgC,eAAA;AA+BlC;AA5BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,qCDvFS;ECwFT,2CAAA;EACA,mBAAA;AA8BJ;AA3BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cD5FQ;EC6FR,4BAAA;AA6BJ;AA3BI;EACE,iBAAA;EACA,gBAAA;AA6BN;AAzBE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA2BJ;AAxBE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA0BJ;AAnBE;EACE,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBD/HK;ECgIL,mCAAA;AAqBJ;AAnBI;EACiB,8BAAA;AAqBrB;AAlBE;EACE,kBAAA;EACA,QAAA;EACA,eAAA;AAoBJ;AAlBI;EACE,oCAAA;EACA,oBAAA;AAoBN;AAhBE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAkBJ;AAhBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,gCAAA;AAkBN;AAdE;EACuC,sBAAA;AAgBzC;AAdE;EACE,kDDlKS;ECmKT,eAAA;EACA,cD1KK;AC0LT;AAbE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,4EAAA;AAeJ;AAZE;EACE,YAAA;EACA,kDDtLS;ECuLT,eAAA;EACA,iBAAA;EACA,cDjMG;ECkMH,yCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAcJ;AAXE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,UAAA;EACA,2BAAA;EACA,oDAAA;AAaJ;AAVE;EAEE,UAAA;EACA,eAAA;AAWJ;AAPE;ED1JA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;EC4GE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,cD/NK;ECgOL,gCAAA;EACA,aAAA;EACA,sGAAA;AAyBJ;AD5KE;EAAyB,qCAAA;EAAuC,8BAAA;ACgLlE;AD/KE;EAA0B,0BAAA;ACkL5B;ADjLE;EAAa,YAAA;EAAc,mBAAA;ACqL7B;ADpLE;EAAkB,oCAAA;EAAsC,mBAAA;ACwL1D;AAtCI;EACE,cDnOG;ECoOH,gCAAA;EACA,qBDrOG;AC6QT;AApCE;EACiC,UAAA;AAsCnC;AAhCE;EACE,aAAA;EACA,qCDzPS;EC0PT,oBAAA;EACA,eAAA;AAkCJ;AAhCI;EACE,oCAAA;EACA,oBAAA;AAkCN;AA/BI;EAAU,qCAAA;AAkCd;AA/BE;EACE,eAAA;AAiCJ;AAhCI;EACiB,sCDrQP;ACuSd;AA/BE;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;AAiCJ;AA9BE;EACE,kDD3QS;EC4QT,eAAA;EACA,cDrRG;ACqTP;AA7BE;EDtOA,eAAA;EACA,gBAAA;EACA,cAlDO;ACwTT;AAhCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;AAkCJ;AAhCI;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4BAAA;EACA,gCAAA;AAiCN;AA/BI;EAAY,WAAA;EAAa,WAAA;AAmC7B;AAlCI;EAAW,UAAA;EAAY,YAAA;AAsC3B;AA/BE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,iCAAA;EACA,kBAAA;AAiCJ;AA9BE;EACE,kDD1TS;EC2TT,eAAA;EACA,gBAAA;EACA,uBAAA;AAgCJ;AA7BE;ED5RA,eAAA;EACA,gBAAA;EACA,cA7CO;ECyUL,mBAAA;AAiCJ;AA9BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAgCJ;AAzBE;EDxRA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EC2QE,kBAAA;EACA,eAAA;AA0CJ;ADpTE;EAAyB,qCAAA;EAAuC,8BAAA;ACwTlE;ADvTE;EAA0B,0BAAA;AC0T5B;ADzTE;EAAa,YAAA;EAAc,mBAAA;AC6T7B;AD5TE;EAAkB,oCAAA;EAAsC,mBAAA;ACgU1D;AAtDE;EDtQA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC+TF;AD7TE;EAAyB,6BAAA;EAA+B,+BAAA;ACiU1D;AA9DE;ED/PA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACgUF;AD9TE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACkaT;AArEE;EDpTA,eAAA;EACA,gBAAA;EACA,cA7CO;ECiWL,kBAAA;EACA,cDnWG;ECoWH,qCDxWS;ECyWT,2CAAA;EACA,8BAAA;EACA,kBDlWK;AC2aT;;AArEA;EACE;IACE,aAAA;EAwEF;EAtEE;IAAU,sBAAA;EAyEZ;EAxEE;IAAc,eAAA;EA2EhB;EA1EE;IAAgB,0BAAA;EA6ElB;EA5EE;IAAU,aAAA;EA+EZ;AACF;AA5EA;EACE;IAAO,UAAA;EA+EP;EA9EA;IAAO,UAAA;EAiFP;AACF;AA/EA;EACE;IAA+B,eAAA;IAAiB,OAAA;IAAS,WAAA;IAAa,YAAA;EAqFtE;EApFA;;IACyB,gBAAA;EAuFzB;AACF;AApFA;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;AAsFF;AApFE;EACE,kBAAA;EACA,QAAA;EACA,4KACE;AAqFN;AAjFE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,+BAAA;EACA,kBAAA;AAmFJ;AAhFE;EACE,+BAAA;EACA,YAAA;EACA,qDAAA;AAkFJ;AA/EE;EACE,uBAAA;EACA,YAAA;AAiFJ;AA9EE;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAgFJ;AA7EE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;AA+EJ;AA7EI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;AA+EN;AA3EE;EACE,SAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AA6EJ;;AAzEA;EACE;IAAO,UAAA;EA6EP;EA5EA;IAAK,UAAA;EA+EL;AACF;AA7EA;EACE;IAAW,sDAAA;EAgFX;EA/EA;IAAM,sDAAA;EAkFN;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Sign-in and character selection. The cards are the point of the screen:\n// big portraits, the name and a \"Jouer\" cue on the footer, delete tucked in\n// the corner. Empty and locked slots share one dashed look.\n\n.auth-panel {\n  @include ink.panel;\n  @include ink.enter;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 100000;\n  width: min(720px, calc(100vw - 32px));\n  max-height: calc(100vh - 32px);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  @include ink.scroll;\n\n  h1, p { margin: 0; }\n\n  &--signin {\n    width: min(420px, calc(100vw - 32px));\n    gap: 14px;\n  }\n\n  // Connection screen after a character was picked.\n  &--launch {\n    width: min(380px, calc(100vw - 32px));\n    align-items: center;\n    gap: 12px;\n    padding: 32px 28px 28px;\n    text-align: center;\n  }\n\n  &__launch-portrait {\n    width: 150px;\n    height: 190px;\n    margin-bottom: 8px;\n    overflow: hidden;\n    background: #07090c;\n    border: 1px solid var(--gold-dark);\n    border-radius: ink.$radius;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center 22%;\n    }\n  }\n\n  &__progress {\n    position: relative;\n    width: 100%;\n    height: 3px;\n    margin-top: 8px;\n    overflow: hidden;\n    background: ink.$line;\n    border-radius: 2px;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      width: 35%;\n      background: var(--gold-main);\n      border-radius: 2px;\n      animation: auth-progress 1.3s ease-in-out infinite;\n    }\n  }\n\n  &__head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20px;\n  }\n\n  &__title { @include ink.title(28px); }\n\n  &__lead {\n    @include ink.lead;\n    margin-top: 6px;\n  }\n\n  &--signin &__lead { margin-top: 0; }\n  &--signin .auth-panel__button { margin-top: 6px; }\n\n  // Account chip, top right of the header.\n  &__identity {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n    max-width: 45%;\n    padding: 5px 14px 5px 5px;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: 24px;\n  }\n\n  &__avatar {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    font-weight: 600;\n    font-size: 15px;\n    color: ink.$on-accent;\n    background: var(--gold-main);\n\n    &--img {\n      object-fit: cover;\n      background: none;\n    }\n  }\n\n  &__username {\n    min-width: 0;\n    font-size: 14px;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__characters {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n\n  // ---------------------------------------------------------------------\n  // Cards\n  // ---------------------------------------------------------------------\n\n  &__card {\n    position: relative;\n    height: clamp(260px, calc(100vh - 290px), 400px);\n    overflow: hidden;\n    background: #07090c;\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n    transition: border-color 0.12s ease;\n\n    &:hover,\n    &:focus-within { border-color: var(--gold-main); }\n  }\n\n  &__card-main {\n    position: absolute;\n    inset: 0;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: 2px solid var(--gold-light);\n      outline-offset: -3px;\n    }\n  }\n\n  &__portrait {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center 22%;\n      transition: transform 0.25s ease;\n    }\n  }\n\n  &__card:hover &__portrait img,\n  &__card:focus-within &__portrait img { transform: scale(1.03); }\n\n  &__fallback {\n    font-family: ink.$font-title;\n    font-size: 64px;\n    color: ink.$text-3;\n  }\n\n  &__card-foot {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 44px 16px 14px;\n    background: linear-gradient(to top, rgba(5, 7, 10, 0.95), rgba(5, 7, 10, 0));\n  }\n\n  &__card-name {\n    min-width: 0;\n    font-family: ink.$font-title;\n    font-size: 21px;\n    line-height: 1.15;\n    color: ink.$text;\n    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.9);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__card-play {\n    flex-shrink: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--gold-light);\n    opacity: 0;\n    transform: translateX(-4px);\n    transition: opacity 0.14s ease, transform 0.14s ease;\n  }\n\n  &__card:hover &__card-play,\n  &__card:focus-within &__card-play {\n    opacity: 1;\n    transform: none;\n  }\n\n  // Delete sits in the corner; quiet until the card is hovered or focused.\n  &__delete {\n    @include ink.button;\n    @include ink.button-sm;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 2;\n    color: ink.$text-2;\n    background: rgba(7, 9, 12, 0.78);\n    opacity: 0.55;\n    transition: opacity 0.12s ease, background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n    &:hover:not(:disabled) {\n      color: ink.$danger;\n      background: rgba(7, 9, 12, 0.92);\n      border-color: ink.$danger;\n    }\n  }\n\n  &__card:hover &__delete,\n  &__card:focus-within &__delete { opacity: 1; }\n\n  // ---------------------------------------------------------------------\n  // Empty and locked slots\n  // ---------------------------------------------------------------------\n\n  &__card--empty {\n    display: flex;\n    background: ink.$ink-raised;\n    border-style: dashed;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: 2px solid var(--gold-light);\n      outline-offset: -3px;\n    }\n\n    &:hover { background: rgba(255, 255, 255, 0.07); }\n  }\n\n  &__card--locked {\n    cursor: pointer;\n    &:hover,\n    &:focus-within { border-color: ink.$line-strong; }\n  }\n\n  &__empty {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 20px;\n    text-align: center;\n  }\n\n  &__empty-title {\n    font-family: ink.$font-title;\n    font-size: 19px;\n    color: ink.$text;\n  }\n\n  &__empty-sub { @include ink.hint; }\n\n  &__plus {\n    position: relative;\n    width: 44px;\n    height: 44px;\n    margin-bottom: 10px;\n    border: 1px solid var(--gold-dark);\n    border-radius: 50%;\n\n    &::before,\n    &::after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      background: var(--gold-main);\n      transform: translate(-50%, -50%);\n    }\n    &::before { width: 16px; height: 2px; }\n    &::after { width: 2px; height: 16px; }\n  }\n\n  // ---------------------------------------------------------------------\n  // Delete confirmation, drawn over the card it concerns\n  // ---------------------------------------------------------------------\n\n  &__confirm {\n    position: absolute;\n    inset: 0;\n    z-index: 3;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: center;\n    gap: 8px;\n    padding: 22px;\n    background: rgba(8, 10, 13, 0.94);\n    text-align: center;\n  }\n\n  &__confirm-title {\n    font-family: ink.$font-title;\n    font-size: 21px;\n    line-height: 1.2;\n    overflow-wrap: anywhere;\n  }\n\n  &__confirm-text {\n    @include ink.lead;\n    margin-bottom: 10px;\n  }\n\n  &__confirm-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  // ---------------------------------------------------------------------\n  // Buttons and messages\n  // ---------------------------------------------------------------------\n\n  &__button {\n    @include ink.button;\n    padding: 11px 18px;\n    font-size: 15px;\n  }\n\n  &__button--primary { @include ink.button-primary; }\n  &__button--danger { @include ink.button-danger; }\n\n  &__message {\n    @include ink.lead;\n    padding: 10px 12px;\n    color: ink.$text;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-left: 3px solid ink.$danger;\n    border-radius: ink.$radius;\n  }\n}\n\n@media (max-width: 560px) {\n  .auth-panel {\n    padding: 18px;\n\n    &__head { flex-direction: column; }\n    &__identity { max-width: 100%; }\n    &__characters { grid-template-columns: 1fr; }\n    &__card { height: 240px; }\n  }\n}\n\n@keyframes auth-progress {\n  from { left: -35%; }\n  to   { left: 100%; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .auth-panel__progress::after { animation: none; left: 0; width: 100%; opacity: 0.5; }\n  .auth-panel__portrait img,\n  .auth-panel__card-play { transition: none; }\n}\n\n// Branded connection screen: shown from the moment a character is picked until the game takes over.\n.auth-splash {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  background-color: #0a0814;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: auth-splash-in 0.5s ease-out both;\n\n  &__veil {\n    position: absolute;\n    inset: 0;\n    background:\n      radial-gradient(ellipse at center, rgba(10, 8, 20, 0.2) 0%, rgba(10, 8, 20, 0.78) 100%),\n      linear-gradient(to bottom, rgba(10, 8, 20, 0.45), rgba(10, 8, 20, 0.7));\n  }\n\n  &__center {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 14px;\n    width: min(460px, calc(100vw - 48px));\n    text-align: center;\n  }\n\n  &__emblem {\n    width: clamp(96px, 16vh, 150px);\n    height: auto;\n    animation: auth-splash-glow 3.2s ease-in-out infinite;\n  }\n\n  &__wordmark {\n    width: min(360px, 70vw);\n    height: auto;\n  }\n\n  &__who {\n    margin: 6px 0 0;\n    font-size: 15px;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: #c9b0ff;\n  }\n\n  &__progress {\n    position: relative;\n    width: 100%;\n    height: 3px;\n    overflow: hidden;\n    background: rgba(236, 234, 245, 0.14);\n    border-radius: 2px;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      width: 35%;\n      background: #7c4de0;\n      border-radius: 2px;\n      animation: auth-progress 1.3s ease-in-out infinite;\n    }\n  }\n\n  &__status {\n    margin: 0;\n    min-height: 1.4em;\n    font-size: 13px;\n    color: #a7a2bd;\n  }\n}\n\n@keyframes auth-splash-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes auth-splash-glow {\n  0%, 100% { filter: drop-shadow(0 0 10px rgba(124, 77, 224, 0.35)); }\n  50% { filter: drop-shadow(0 0 26px rgba(124, 77, 224, 0.75)); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
